import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const nlCommon = require('./locales/nl/common.json');
const nlDatatypes = require('./locales/nl/datatypes.json');
const nlOutreach = require('./locales/nl/outreach.json');
const nlContactpoint = require('./locales/nl/contactpoint.json');
const nlAutomatictask = require('./locales/nl/automatictask.json');
const nlClient = require('./locales/nl/client.json');
const nlCompanies = require('./locales/nl/companies.json');
i18n

  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: 'nl', // Default language
    lng: 'nl', // Initial language
    debug: true, // Enable debug mode in development
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    resources: {
      nl: {
        common: nlCommon,
        datatypes: nlDatatypes,
        outreach: nlOutreach,
        contactpoint: nlContactpoint,
        automatictask: nlAutomatictask,
        client: nlClient,
        companies: nlCompanies,
      },
    },
  });

export default i18n;